import type {Ng2StateDeclaration} from '@uirouter/angular';

/**
 * This dummy state is used to navigate to after OIDC login.
 * Since it's a "real" state, the OAuthService will parse the URL - no resolves or backend requests are triggered,
 * such that the auth flow can take it's course with a final navigation to dashboard after login
 */
export const OIDC_LANDING_STATE = {
    name: 'base.oidc-landing',
    url: '/landing?code&state&session_state&iss&error&error_description&error_uri',
    data: {
        permissions: [],
    },
} satisfies Ng2StateDeclaration;

export const EXPIRED_STATE = {
    name: 'base.expired',
    url: '/expired',
    data: {
        permission: null,
    },
} satisfies Ng2StateDeclaration;
